import {NgModule} from '@angular/core';
import {ImageLazyLoadDirective} from './image-lazy-load.directive';

@NgModule({
  declarations: [ImageLazyLoadDirective],
  exports: [ImageLazyLoadDirective],
})
export class ImageLazyLoadDirectiveModule {}
